import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { notification, theme, Tooltip } from 'antd';
import workingAreas from 'constants/WorkingAreas';
import { getDataEntryAreasContent } from 'constants/dataEntryAreas';
import TitleBar from 'components/TitleBar';
import { TitleList } from 'store/ducks/globalTypes';
import ApiService from 'utils/ApiCalls';
import { RootState } from 'store/configureStore';
import { useTranslation } from 'react-i18next';
import * as Styled from './WorkingAreas.styled';

const { useToken } = theme;

const WorkingAreasPage = () => {
  const [searchParams] = useSearchParams();
  const { superAdmin, scheme } = useSelector(
    (state: RootState) => state.global,
  );
  const areas = workingAreas();
  const navigate = useNavigate();
  const { token } = useToken();
  const { t } = useTranslation();

  const dataEntryAreasContent = getDataEntryAreasContent(t);

  useEffect(() => {
    const urlToken = searchParams.get('token');

    if (!urlToken) {
      navigate('/', { replace: true });
      return;
    }

    const verifyLogin = async () => {
      if (superAdmin) {
        try {
          const { data } = await ApiService.verifySuperAdminLogin(urlToken);
          const verifiedToken = data.token;
          const role = data.user.role;
          localStorage.setItem('authToken', verifiedToken);
          localStorage.setItem('roles', JSON.stringify(role));
          if (localStorage.getItem('roles') === '"super_user"') {
            navigate('/super_admin', { replace: true });
          }
          notification.success({
            message: 'Info',
            description: data.message,
            duration: 20,
          });
        } catch (error) {
          notification.error({
            message: 'Info',
            description: 'Invalid or expired login link.',
          });
          // navigate('/', { replace: true });
        }
      } else {
        try {
          const { data } = await ApiService.verifyLogin(urlToken);

          const verifiedToken = data.token;
          const roles = data.user.roles;
          localStorage.setItem('authToken', verifiedToken);
          localStorage.setItem('role', JSON.stringify(roles));

          notification.success({
            message: 'Info',
            description: data.message,
            duration: 20,
          });

          navigate('/working_area', { replace: true });
        } catch (error) {
          notification.error({
            message: 'Info',
            description: 'Invalid or expired login link.',
          });
          // navigate('/', { replace: true });
        }
      }
    };

    verifyLogin();
  }, [searchParams, navigate]);
  const groupedAreas: { [key: string]: typeof areas } = {};
  areas.forEach((area) => {
    if (!groupedAreas[area.infoText]) {
      groupedAreas[area.infoText] = [];
    }
    groupedAreas[area.infoText].push(area);
  });
  return (
    <Styled.WorkingLayout>
      <TitleBar title={t(TitleList.WORKING_AREAS)} />
      <Styled.Container>
        {Object.entries(groupedAreas).map(([sectionTitle, items]) => (
          <>
            <Styled.SectionTitle token={token}>
              {sectionTitle}
            </Styled.SectionTitle>
            <Styled.Section
              key={sectionTitle}
              section={sectionTitle}
              token={token}
            >
              <Styled.List>
                {items.map((item) => {
                  const isDataEntry = item.key === '1';
                  const cardLine = (
                    <Styled.CardLine
                      key={item.area}
                      to={item.href}
                      theme={scheme}
                    >
                      <div>
                        <Styled.LineText>{item.area}</Styled.LineText>
                      </div>
                    </Styled.CardLine>
                  );

                  return isDataEntry ? (
                    <Tooltip
                      key={item.area}
                      title={
                        <div>
                          {dataEntryAreasContent.map((area, index) => (
                            <div key={index}>{area}</div>
                          ))}
                        </div>
                      }
                      placement="right"
                    >
                      {cardLine}
                    </Tooltip>
                  ) : (
                    cardLine
                  );
                })}
              </Styled.List>
            </Styled.Section>
          </>
        ))}
      </Styled.Container>
    </Styled.WorkingLayout>
  );
};

export default WorkingAreasPage;
